module.exports = __webpack_public_path__ + "static/img/award2.ab45e76.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award2.png
// module id = zpaB
// module chunks = 7